<script>
  import InterviewContainer from "./InterviewContainer.svelte";
  import Paragraph from "./Paragraph.svelte";
  export let episode = null;
</script>

<!-- <Paragraph
  >Conversational interviews with the artist, conducted during the project's
  research and development phase.</Paragraph
> -->

<InterviewContainer {episode}></InterviewContainer>
